<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">投诉办结</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="投诉内容">
                <el-input
                  v-model="Content"
                  placeholder="请输入投诉内容"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12">
              <el-form-item label="投诉日期">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 60rem"
                  unlink-panels
                  :clearable="false"
                ></el-date-picker> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item label="投诉来源">
                <el-select v-model="ComplaintSource" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintSourceArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="投诉状态">
                <el-select v-model="ComplaintStatus" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintStatusArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item label="投诉类型">
                <el-select v-model="ComplaintSubType" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintSubTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item label="投诉部门">
                <el-select v-model="ComplaintDepartmentId" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintDepartments"
                    :key="item.OrgId"
                    :label="item.OrgName"
                    :value="item.OrgId"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd" v-if="isAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Content"
                label="投诉内容"
              ></el-table-column>
              <el-table-column
                prop="ComplaintSource"
                label="投诉来源"
                :formatter="SourceToNameConverter"
              ></el-table-column>
              <el-table-column
                prop="ComplaintTime"
                label="投诉时间"
                :formatter="formatDate"
              ></el-table-column>
              <el-table-column prop="ComplainUser" label="投诉人">
              </el-table-column>
              <el-table-column
                prop="ContactTel"
                label="联系电话"
              ></el-table-column>
              <el-table-column
                prop="ComplaintStatus"
                label="投诉状态"
                :formatter="StatusToNameConverter"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="120"
                align="center"
                v-if="!IsAdministrator"
              >
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >操作</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
export default {
  name: "ComplaintFinishView",
  controller: "UI",
  action: "ComplaintFinishView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      Content: "",
      loading: false,
      loadingText: "加载中...",
      date: [new Date(new Date() - 90 * 24 * 60 * 60 * 1000), new Date()],
      //TODO 可配置下拉菜单
      ComplaintSource: "",
      ComplaintSourceArr: [
        { value: 6, label: "电话" },
        { value: 7, label: "其他" },
      ],
      ComplaintStatus: "",
      ComplaintStatusArr: [
        { value: 1, label: "待受理" },
        { value: 2, label: "已受理" },
        { value: 3, label: "不受理" },
        { value: 4, label: "已处理" },
        { value: 5, label: "已结案" },
      ],
      ComplaintSubType: "",
      ComplaintSubTypeArr: [
        { value: 1, label: "景区投诉" },
        { value: 2, label: "环境投诉" },
        { value: 3, label: "服务投诉" },
        { value: 4, label: "物价投诉" },
        { value: 5, label: "其他投诉" },
      ],
      ComplaintDepartmentId: "",
      ComplaintDepartments: [],
      isAdd: false,
      ComplaintStatuses: [],
      ComplaintDepartmentIds: [],
      IsAdministrator: false,
    };
  },
  created: function() {
    this.GetUserIsAdministrator();
  },
  mounted: function() {
    this.getTopDepartments();
    this.init();
    setTimeout(() => {
      this.search();
    }, 300);
    this.logInfo.ActionName = "投诉管理查询";
    this.logInfo.LogMessage = "投诉管理查询";
    this.logInfo.ModuleName = "投诉系统";
    this.logInfo.PageName = "投诉管理列表";
    this.addOperationLog();
  },
  methods: {
    //绑定部门信息
    getTopDepartments() {
      new Apis.OrgApi()
        .FindByConditions({ OrgCode: this.config.app.org_code })
        .then((r) => {
          r = r.data.Data;
          if (r != null && r.length > 0) {
            this.getDepartments(r[0].OrgId);
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getDepartments(OrgId) {
      new Apis.OrgApi()
        .FindByConditions({ ParentOrgId: OrgId })
        .then((r) => {
          r = r.data.Data;
          this.ComplaintDepartments = r;
          // if (
          //   !this.IsAdministrator &&
          //   this.user.Departments != null &&
          //   this.user.Departments.length > 0 &&
          //   this.user.Role[0].data.Data.RoleName != "投诉受理岗"
          // ) {
          //   this.ComplaintDepartments = this.ComplaintDepartments.filter(
          //     (p) => {
          //       return p.OrgId == this.user.Departments[0].OrgId;
          //     }
          //   );
          //   this.ComplaintDepartmentIds = this.ComplaintDepartments.map(
          //     (item) => {
          //       return item.OrgId;
          //     }
          //   );
          // }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetUserIsAdministrator() {
      let user = this.user;
      var userId = user.UserId;
      let RoleInfoSearch = {
        UserId: userId,
      };
      new Apis.RoleApi()
        .IsAdministrator(RoleInfoSearch)
        .then((r) => {
          r = r.data.Data;
          this.IsAdministrator = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    init() {
        this.ComplaintStatusArr = [
          { value: 4, label: "已处理" },
          { value: 5, label: "已结案" },
        ];
        if (this.ComplaintStatusArr.length > 0) {
          this.ComplaintStatuses = this.ComplaintStatusArr.map((item) => {
            return item.value;
          });
        }
    },
    search() {
      let searchInfo = {
        Content: this.Content,
        ComplaintStartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        ComplaintEndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
        ComplaintStatus: this.ComplaintStatus == "" ? 0 : this.ComplaintStatus,
        ComplaintStatuses: this.ComplaintStatuses,
        ComplaintType: this.ComplaintType == "" ? 0 : this.ComplaintType,
        ComplaintSubType:
          this.ComplaintSubType == "" ? 0 : this.ComplaintSubType,
        ComplaintSource: this.ComplaintSource == "" ? 0 : this.ComplaintSource,
        ComplaintDepartmentId:
          this.ComplaintDepartmentId == "" ? "0" : this.ComplaintDepartmentId,
        ComplaintDepartmentIds: this.ComplaintDepartmentIds,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loading = true;
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/complaint/UI/ComplaintManagerInfo",
        query: {
          type: "add",
          formShow: "accept",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/complaint/ui/ComplaintManagerInfo",
        query: { Info: row, InfoId: row.Id, type: "edit", formShow: "accept" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/smartTrash/ui/SmartTrashManagerInfo",
        query: { InfoId: row.ID, type: "edit" },
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.Content = "";
      this.ComplaintStatus = "";
      this.ComplaintType = "";
      this.ComplaintSubType = "";
      this.ComplaintSource = "";
      this.ComplaintDepartmentId = "";
      this.date = [new Date(new Date() - 90 * 24 * 60 * 60 * 1000), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    SourceToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const SourceName = this.ComplaintSourceArr.map((item) => {
        if (item.value == data) return item.label;
      }).join("");
      if (SourceName == null || SourceName == "") {
        return data;
      }
      return SourceName;
    },
    StatusToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const StatusName = this.ComplaintStatusArr.map((item) => {
        if (item.value == data) return item.label;
      }).join("");
      if (StatusName == null || StatusName == "") {
        return data;
      }
      return StatusName;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    }
  }
}
</script>
